import { SelectNavigation } from "./SelectNavigation";
import { ChapterViewMenu } from "./ChapterViewMenu";
import { Button } from "@mui/material";
import { select } from "@wordpress/data";
import DOMPurify from "dompurify";
import { STORE_NAME } from "../store";
import parse from "html-react-parser";
import { Shortcut, AddShoppingCart, Download } from '@mui/icons-material';

const truncateWords = (text, wordLimit) => {
	if (!text) return '';
	const words = text.split(' ');
	return words.length > wordLimit ? words.slice(0, wordLimit).join(' ') + '...' : text;
};


export const Sidebar = () => {
	const {image, price, link, content } = select( STORE_NAME ).getProductData();
	const { title, permalink } = select( STORE_NAME ).getBookData();

	return (
		<div id="sidebar" className="sticky top-10">
			
			<div>
				<div><img src={image} alt={title} className="shadow mb-1 rounded-md"/></div>
				<b><a href={link}>{title}</a></b>
				<div>
					{parse( DOMPurify.sanitize( truncateWords( content,40 ) ) )}
					{" "}<a href={link}>קרא עוד</a>
				</div>
				<b>{price} ש"ח</b>
				<p>המחיר כולל משלוח בארץ</p>
				<Button variant="contained" href={link} className="mt-2 bbt-btn w-full">
					<span>קנה עכשיו</span>
					<AddShoppingCart />
				</Button>
			</div>
			<div className="mt-5">
				<Button variant="contained" href="/?page_id=150" className="bbt-btn w-full">
				הורדה	
					<Download/>
				</Button>
			</div>
		
		</div>
	);
};


